import request from '@/utils/request'

const classifyURL = {
  Created: '/article-type/create',
  List: '/article-type/list',
  ListTree: '/article-type/list-tree',
  Update: '/article-type/update',
  Delete: '/article-type/delete',
  ArticleTemplateItems: '/article-template/items',
  ArticleTemplateCreate: '/article-template/create',
  ArticleTemplateUpdate: '/article-template/update',
  ArticleTemplateDelete: '/article-template/delete',
}

// 创建文章分类
export function createClassify (data) {
  return request({
    url: classifyURL.Created,
    method: 'post',
    data
  })
}

// 文章分类列表
export function listClassify (data) {
  return request({
    url: classifyURL.List,
    method: 'post',
    data
  })
}

// 文章分类列表(树状)
export function listClassifyTree (data) {
  return request({
    url: classifyURL.ListTree,
    method: 'post',
    data
  })
}

// 更新文章分类
export function updateClassify (data) {
  return request({
    url: classifyURL.Update,
    method: 'post',
    data
  })
}

// 删除文章分类
export function deleteClassify (data) {
  return request({
    url: classifyURL.Delete,
    method: 'post',
    data
  })
}

// 生成文章模板-列表
export function articleTemplateItems (data) {
  return request({
    url: classifyURL.ArticleTemplateItems,
    method: 'post',
    data
  })
}

// 生成文章模板-新建
export function articleTemplateCreate (data) {
  return request({
    url: classifyURL.ArticleTemplateCreate,
    method: 'post',
    data
  })
}

// 生成文章模板-编辑
export function articleTemplateUpdate (data) {
  return request({
    url: classifyURL.ArticleTemplateUpdate,
    method: 'post',
    data
  })
}

// 生成文章模板-删除
export function articleTemplateDelete (data) {
  return request({
    url: classifyURL.ArticleTemplateDelete,
    method: 'post',
    data
  })
}

export default {
  createClassify,
  listClassify,
  listClassifyTree,
  updateClassify,
  deleteClassify,
  articleTemplateItems,
  articleTemplateCreate,
  articleTemplateUpdate,
  articleTemplateDelete
}
